// extracted by mini-css-extract-plugin
export default {"list":"J2_inJ","item":"iLQ18s","label":"N_Q6Uk"};